import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ApiResponse, PaginatedResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

export type AnnouncementSubscriber = {
    mail: string;
    source: string;
};

export type FetchSubscribersPayload = {
    email?: string;
    pageIndex?: number;
    pageSize?: number;
    sortCriteria?: "mail" | "source";
    sortDirection?: 0 | 1;
};

export type UnsubscribePayload = {
    emails: string[];
    reason?: string;
};

export type UnsubscribeResult = {
    removed: string[];
    unknown: string[];
};

type UnsubscribeRequestBody = {
    Emails: string[];
    Reason?: string;
};

export async function fetchSubscribers(payload?: FetchSubscribersPayload) {
    try {
        const endpoint = await RouteService.getAnnouncementsRoute();
        const { data } = await HttpService.get<PaginatedResponse<AnnouncementSubscriber>>(endpoint + "subscribers", {
            params: {
                Email: payload?.email,
                PageIndex: payload?.pageIndex,
                PageSize: payload?.pageSize,
                SortCriteria: payload?.sortCriteria,
                SortDirection: payload?.sortDirection,
            },
        });
        return data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function unsubscribeSubscribers(payload: UnsubscribePayload): Promise<UnsubscribeResult> {
    try {
        const endpoint = await RouteService.getAnnouncementsRoute();
        const requestBody: UnsubscribeRequestBody = {
            Emails: payload.emails,
        };

        const trimmedReason = payload.reason?.trim();
        if (trimmedReason) {
            requestBody.Reason = trimmedReason;
        }

        const { data } = await HttpService.post<ApiResponse<UnsubscribeResult>>(endpoint + "unsubscribe", requestBody, {
            headers: { "Content-Type": "application/json" },
        });

        return {
            removed: data.model?.removed ?? [],
            unknown: data.model?.unknown ?? [],
        };
    } catch (error) {
        throw unpackError(error);
    }
}
